const AUTH_DOMAIN = process.env.VUE_APP_AUTH_DOMAIN
const AUTH_CLIENT_ID = process.env.VUE_APP_AUTH_CLIENT_ID

export const Auth0Config = Object.freeze({
	domain: AUTH_DOMAIN,
	clientId: AUTH_CLIENT_ID
})
